import React, { createContext, useContext, useEffect, useState } from 'react'
import { GetBayLocations } from '../graphQL/BayLocations'
import { LocationsInterface } from '../pages/ReceivablesForm/Table/Locations'

type Props = { children: React.ReactNode}

interface BayLocationsContextProps {
  bayLocations: LocationsInterface[]
}

const BayLocationsContext = createContext<BayLocationsContextProps | undefined>(undefined)

export const BayLocationsProvider = ({ children }: Props) => {
  const [bayLocations, setBayLocations] = useState<LocationsInterface[]>([])

  useEffect(() => {
    async function fetchLocations() {
      const locations = await GetBayLocations()
      setBayLocations(
        locations?.map((bay: LocationsInterface) => ({
          Location: bay.Location,
          BayID: bay.BayID
        })) || []
      )
    }

    fetchLocations()
  }, [])

  return (
    <BayLocationsContext.Provider value={{ bayLocations }}>
      {children}
    </BayLocationsContext.Provider>
  )
}

export const useBayLocations = (): BayLocationsContextProps => {
  const context = useContext(BayLocationsContext)
  if (!context) {
    throw new Error('useBayLocations must be used within a BayLocationsProvider')
  }
  return context
}
